export default __webpack_public_path__ + "static/media/SwissFlag.c4fedbdc.svg";